import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainLayoutComponent } from 'src/app/shared/components/main-layout/main-layout.component';
import { Option } from '../app.model';
import { Observable, of } from 'rxjs';
import { FINANCING_EDUCATION } from './financing-education.const';

@Component({
  selector: 'app-financing-education',
  standalone: true,
  imports: [
    CommonModule,
    MainLayoutComponent,
  ],
  templateUrl: './financing-education.component.html',
  styleUrl: './financing-education.component.scss',
})
export class FinancingEducationComponent implements OnInit {
  loanTerm: {
    title: string;
    text: string;
    loanTermOptions: Option[];
  };
  downPayment: {
    title: string;
    text: string;
    downPaymentOptions: Option[];
  };
  logicMap: {
    initial_cost: string;
    map: {
      unique_names_combination: string;
      value: string;
    }[];
  };
  percentageIncrease: number = 0;
  finalValue: string;

  constructor() {}

  ngOnInit() {
    this.loanTerm = FINANCING_EDUCATION.loanTerm;
    this.downPayment = FINANCING_EDUCATION.downPayment;
    this.logicMap = FINANCING_EDUCATION.logicMap;
    this.setupResult();
  }

  onSelect(item, list) {
    if (!item.selected) {
      const listItem = list.split(' ');
      if (listItem) {
        this[listItem[0]][listItem[1]].map((listItem) =>
          item.unique_name === listItem.unique_name
            ? (listItem.selected = !listItem.selected)
            : (listItem.selected = false)
        );
        this.setupResult();
      }
    }
  }

  setupResult() {
    const loanTerm = this.loanTerm?.loanTermOptions?.find(
      (item) => item.selected
    ).unique_name;
    const downPayment = this.downPayment?.downPaymentOptions?.find(
      (item) => item.selected
    ).unique_name;
    const key = `${loanTerm} ${downPayment}`;
    const original = this.formatNumber(this.logicMap.initial_cost);
    this.finalValue = this.logicMap.map.find(
      (item) => item.unique_names_combination === key
    ).value;
    if (this.finalValue) {
      const newVal = this.formatNumber(this.finalValue);
      this.percentageIncrease = ((newVal - original) / original) * 100;
    }
  }

  formatNumber(value: string): number {
    return parseFloat(value.replace(/,/g, ''));
  }

  onClickBack = (): Observable<any> => {
    return of(true);
  };
}
